import { render } from "./SaveChart.vue?vue&type=template&id=083a3806"
import script from "./SaveChart.vue?vue&type=script&lang=js"
export * from "./SaveChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__